const baseURL = "/v1/Acesso";

const service = {
  methods: {
    $solicitarRecuperacaoSenha(body) {
      return this.$api().post(`${baseURL}/SolicitarRecuperacaoSenha`, body);
    },
    $mudarSenhaPorRecuperacao(body) {
      return this.$api().post(`${baseURL}/MudarSenhaPorRecuperacao`, body);
    }
  }
}

export default service;